import { Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../../../context/SidebarContext';
import { useAuth } from '../../../hooks/useAuth';
import { menuService } from '../../../services/menu.service';
import LogoIcon from '../icons/LogoIcon';
import UserProfileIcon from '../icons/UserProfileIcon';
import './Header.css';

interface HeaderProps {
  // Add any props if needed
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { toggleSidebar, setMenu } = useSidebar();
  const [isLoading, setIsLoading] = useState(true);
  const [topMenus, setTopMenus] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedTopMenuId, setSelectedTopMenuId] = useState<number>(0);
  const [logoutAnchorEl, setLogoutAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const logoutOpen = Boolean(logoutAnchorEl);

  useEffect(() => {
    setIsLoading(true);
    menuService.getTopMenus().then((res) => {
      setTopMenus(res.data.data ?? []);
      setSelectedTopMenuId(res.data.data[0].menuId);
      setIsLoading(false);
    }).catch((err) => {
      console.log(err);
      setIsLoading(false);
    })
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, menuId: number) => {
    setSelectedTopMenuId(menuId);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubMenuClick = (menuId: number) => {
    menuService.getLeftMenu(menuId).then((res) => {
      setIsLoading(false);
      setMenu({
        items: (res.data.data ?? []).map((item: any) => ({
          label: item.name,
          path: item.route
        }))
      });
      navigate(res.data.data[0].route);
    }).catch((err) => {
      console.log(err);
      setIsLoading(false);
    })
    handleClose();
  };

  

  const handleLogoutClick = (event: React.MouseEvent<HTMLElement>) => {
    setLogoutAnchorEl(event.currentTarget);
  };

  const handleLogoutClose = () => {
    setLogoutAnchorEl(null);
  };

  const handleLogout = () => {
    handleLogoutClose();
    logout();
    navigate('/?logout=1');
  };

  return (
    <header className="top-header" id="top-header">
      <div className="header-left">
        <div className="logo logo-img">
          <LogoIcon />
        </div>
        <nav className="main-nav">
          {isLoading ? (
            <></>
          ) : (
            <>
              {topMenus.map((menu) => (
                <button
                  type="button"
                  key={menu.menuId}
                  aria-haspopup="true"
                  onClick={(e) => handleMenuClick(e, menu.menuId)}
                  aria-expanded={open ? 'true' : undefined}
                  aria-controls={open ? menu.menuId : undefined}
                  className={`nav-link ${menu.menuId === selectedTopMenuId ? 'active' : ''}`}
                >
                  {menu.name}
                </button>
              ))}
            </>
          )}
        </nav>
      </div>
      <div className="header-right">
        <div
          className="user-profile"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/user/profile')}
          aria-label="User profile"
          role="button"
        >
          <UserProfileIcon color="#FFFFFF" />
        </div>
        <button className="menu-btn" onClick={toggleSidebar}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 5H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.5 10H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.5 15H17.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        
        <button className="dropdown-btn" onClick={handleLogoutClick}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        

      </div>

      {isLoading ? (
        <></>
      ) : (
        <>
          {topMenus.map((menu) => (
            <React.Fragment key={menu.menuId}>
              <Menu
                open={open && menu.menuId === selectedTopMenuId}
                id={menu.menuId}
                anchorEl={anchorEl}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': menu.id,
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                {menu.children.map((item: any) => (
                  <MenuItem onClick={() => handleSubMenuClick(item.menuId)} key={item.menuId}>{item.name}</MenuItem>
                ))}
              </Menu>
            </React.Fragment>
          ))}
        </>
      )}

      {/* Logout Menu */}
      <Menu
        open={logoutOpen}
        anchorEl={logoutAnchorEl}
        onClose={handleLogoutClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </header>
  );
};

export default Header; 